import React, { useState, useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import axios from "axios";
import { useSelector } from "react-redux";
import notify from "../../ReusableComponents/ToastifyAlerts";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import axiosInstance from "../../ReusableComponents/Axios";

const StudentDeactivation = () => {
    const { SetLoad } = useContext(LoadContext);
    const [studentId, setStudentId] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showNote, setShowNote] = useState(false);
    const [alreadyDeactivatedIds, setAlreadyDeactivatedIds] = useState([]);
    const [invalidStudentIds, setInvalidStudentIds] = useState([]);
    const [notExistsStudentIds, setNotExistsStudentIds] = useState([]);
    const [repeatedStudentIds, setRepeatedStudentIds] = useState([]);
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const [Students, SetStudents] = useState([]);
    const Columns = [
        { name: "Student Id", selector: "studentId", sortable: true },
        {
            name: "Student Name",
            selector: "studentName",
            sortable: true,
        },
        { name: "Grade", selector: "grade", sortable: true },
        { name: "Section", selector: "section", sortable: true },
    ];

    // const handleOk = async () => {
    //     if (!studentId.trim()) {
    //         notify("Please enter Student ID");
    //         return;
    //     }

    //     const studentIds = studentId
    //         .split(",")
    //         .map((id) => id.trim())
    //         .filter((id) => id !== "");

    //     if (studentIds.length > 10) {
    //         notify("You can deactivate a maximum of 10 students at a time.");
    //         return;
    //     }
    //     const invalidIds = studentIds.filter((id) => !/^\d{10}$/.test(id));
    //     const validIds = studentIds.filter((id) => /^\d{10}$/.test(id));
    //     setInvalidStudentIds(invalidIds);
    //     setAlreadyDeactivatedIds([]);
    //     // If there are no valid IDs, don't call API
    //     if (validIds.length === 0) {
    //         SetStudents([]);
    //         setShowNote(false);
    //         return;
    //     }
    //     SetLoad((prev) => !prev);
    //     try {
    //         const res = await axiosInstance.get(
    //             `/NCLAdmin/GetStudentDetailsbyLoginIds`,
    //             {
    //                 params: {
    //                     LoginId: validIds.join(","),
    //                 },
    //             }
    //         );
    //         const students = res.data || [];
    //         // No valid students found
    //         if (students.length === 0) {
    //             SetStudents([]);
    //             setShowNote(false);
    //             setAlreadyDeactivatedIds(validIds);
    //             return;
    //         }
    //         SetStudents(students);
    //         // IDs returned from API
    //         const returnedStudentIds = students.map((student) =>
    //             String(student.studentId).trim()
    //         );
    //         // Valid IDs which were not returned by API
    //         const deactivatedIds = validIds.filter(
    //             (id) => !returnedStudentIds.includes(String(id))
    //         );
    //         setAlreadyDeactivatedIds(deactivatedIds);
    //         setShowNote(true);
    //     } catch (err) {
    //         console.error(err);
    //         SetStudents([]);
    //         setShowNote(false);
    //         notify("Unable to fetch student details.", "error");
    //     } finally {
    //         SetLoad((prev) => !prev);
    //     }
    // };
    const handleOk = async () => {
        if (!studentId.trim()) {notify("Please enter Student ID");return;
        }
        const studentIds = studentId.split(",").map((id) => id.trim()).filter((id) => id !== "");
        const duplicateIds = studentIds.filter((id, index) => studentIds.indexOf(id) !== index);
        const repeatedIds = [...new Set(duplicateIds)];
        setRepeatedStudentIds(repeatedIds);
        const uniqueStudentIds = [...new Set(studentIds)];
        if (studentIds.length > 10) {
            notify("You can deactivate a maximum of 10 students at a time.");
            return;
        }
        // Invalid IDs
        const invalidIds = uniqueStudentIds.filter((id) => !/^\d{10}$/.test(id));
        const validIds = uniqueStudentIds.filter((id) => /^\d{10}$/.test(id));
        setInvalidStudentIds(invalidIds);
        setAlreadyDeactivatedIds([]);

        if (validIds.length === 0) {
            SetStudents([]);
            setShowNote(false);
            return;
        }
        SetLoad((prev) => !prev);
        try {
            const res = await axiosInstance.get(
                `/NCLAdmin/GetStudentDetailsbyLoginIds`,{params: {LoginId: validIds.join(","),},});
            const result = res.data || [];
            const notExistsIds = result
                .filter((student) => student.studentStatus === "NotExists")
                .map((student) => student.studentId);
            const deactivatedIds = result
                .filter((student) => student.studentStatus === "AlreadyDeactivated")
                .map((student) => student.studentId);
            const activeStudents = result.filter(
                (student) => student.studentStatus === "Active"
            );
            setNotExistsStudentIds(notExistsIds);
            setAlreadyDeactivatedIds(deactivatedIds);
            SetStudents(activeStudents);
            setShowNote(activeStudents.length > 0);

        } catch (err) {
            console.error(err);
            SetStudents([]);
            setShowNote(false);
            notify("Unable to fetch student details.", "error");
        } finally {
            SetLoad((prev) => !prev);
        }
    };
    const handleClear = () => {
        setStudentId("");
        SetStudents([]);
        setShowNote(false);
        setShowConfirm(false);
        setAlreadyDeactivatedIds([]);
        setInvalidStudentIds([]);
        setNotExistsStudentIds([]);
        setRepeatedStudentIds([]);
    };

    const handleConfirm = async () => {
        setShowConfirm(false);
        setLoading(true);
        const studentIds = studentId.split(",").map((id) => id.trim()).filter((id) => id !== "");
        const ApiDetails = {loginIds: studentIds.map(String),modifiedBy: items?.userId,};
        try {
            await axios.post(process.env.REACT_APP_API_BASE_URL + `/NCLAdmin/UpdateBulkStudentStatus`,
                ApiDetails,
                { headers: { XApiKey: process.env.REACT_APP_XApiKey, }, }
            );
            notify("Students were deactivated successfully.", "success");
            setStudentId("");
            handleClear();
        } catch (err) {
            console.error(err);
            notify("Students could not be deactivated.", "error");
        } finally {
            setLoading(false);
        }
    };
    const handleCancel = () => { setShowConfirm(false); };
    return (
        <>
            <div className="TeacherBgImage">
                <div className="MainHeading" style={{ marginTop: "10px" }}>Students Deactivation</div>
                <div className="SubHeading mt-4">Enter Student ID(s) to Deactivate:</div>
                <Row className="mt-4">
                    <Col md={8}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Student ID"
                            value={studentId}
                            onChange={(e) => {
                                setStudentId(e.target.value);
                                setAlreadyDeactivatedIds([]);
                                setInvalidStudentIds([]);
                                setNotExistsStudentIds([]);
                                setRepeatedStudentIds([]);
                                setShowNote(false);
                                SetStudents([]);
                            }}
                            disabled={loading}
                        />
                    </Col>
                    <Col md={4} className="d-flex align-items-end"
                    >
                        <button type="button" className="Buttons" onClick={handleOk} disabled={loading}
                        >
                            {loading ? "Processing..." : "OK"}
                        </button>
                    </Col>
                </Row>
                {invalidStudentIds.length > 0 && (
                    <div className="mt-2 text-danger">
                        <b>
                            StudentId(s):{" "}
                            {invalidStudentIds.map((id) => `"${id}"`).join(", ")}
                            {" "}are invalid.
                        </b>
                    </div>
                )}

                {notExistsStudentIds.length > 0 && (
                    <div className="mt-2 text-danger">
                        <b>
                            StudentId(s): {notExistsStudentIds.join(", ")} do not exist.
                        </b>
                    </div>
                )}

                {alreadyDeactivatedIds.length > 0 && (
                    <div className="mt-2 text-danger">
                        {alreadyDeactivatedIds.length ===
                            studentId
                                .split(",")
                                .map((id) => id.trim())
                                .filter((id) => /^\d{10}$/.test(id)).length ? (
                            <b>Student(s) already Deactivated.</b>
                        ) : (
                            <b>
                                StudentId(s): {alreadyDeactivatedIds.join(", ")} already Deactivated.
                            </b>
                        )}
                    </div>
                )}
                {repeatedStudentIds.length > 0 && (
                    <div className="mt-2 text-danger">
                        <b>
                            StudentId(s):{" "}
                            {repeatedStudentIds.map((id) => `"${id}"`).join(", ")}
                            {" "}
                            {repeatedStudentIds.length === 1 ? "is repeated." : "are repeated."}
                        </b>
                    </div>
                )}


                {showNote && Students.length > 0 && (
                    <Row className="align-items-center mt-3">
                        <Col md={12} className="d-flex align-items-center">

                            <b
                                style={{
                                    animation: "blink 1s infinite",
                                    marginLeft: "auto",
                                    marginRight: "15px"
                                }}
                            >
                                Click Confirm to proceed with the Deactivation.
                            </b>

                            <button
                                type="button"
                                className="Buttons"
                                onClick={() => setShowConfirm(true)}
                            >
                                Confirm Deactivation
                            </button>

                            <button
                                type="button"
                                className="Buttons bg-danger"
                                onClick={handleClear}
                                style={{ marginLeft: "8px" }}
                            >
                                Cancel
                            </button>

                        </Col>
                    </Row>
                )}
                {/* <DataTable data={Students} columns={Columns} className="NCLDataTable Card mt-3" /> */}
                <DataTable data={Students} columns={Columns} className="NCLDataTable Card mt-2"
                    Dropdownvalues={["10", "25", "50", "100"]} ShowPagination={true} ShowPagecount={true} />

            </div>
            {showConfirm && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Confirm Deactivation
                                </h5>
                                <button type="button" className="btn-close" onClick={handleCancel}></button>
                            </div>

                            <div className="modal-body">
                                <p className="mb-0">Are you sure you want to Deactivate students?{" "}</p>
                                <p className="text-danger mt-2 mb-0">
                                    Once Deactivated, the student will not be able to login to the application.
                                </p>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="Buttons bg-danger"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>
                                <button type="button" className="Buttons" onClick={handleConfirm} disabled={loading}
                                >
                                    Ok
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default StudentDeactivation;